import superagent, { Response, ResponseError } from 'superagent';


const methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path: string,server:string) {
    let url;
    if(server==='SC'){
        url =process.env.REACT_APP_SPACECRAFT_DRAWING_URL
    }
    else {
        url =process.env.REACT_APP_DRAWING_API_URL
        const adjustedPath = path[0] !== '/' ? `/${path}` : path;
        return url + adjustedPath;
    }
    return url + path;
    // return `http://localhost:9090${adjustedPath}`
}

type APIRequest = {
    params?: string | object;
    data?: string | object;
    timeout?: number | { deadline?: number; response?: number };
    authToken?: string | object;
    serverName?: string;
};

class wizardClient {
    post: any;
    get: any;
    put: any;
    patch: any;
    del: any;

    token: string;

    constructor() {
        methods.forEach(
            method =>
                (this[method] = (
                    path: string,
                    { params, data, timeout, authToken,serverName }: APIRequest = {}
                ) =>
                    new Promise((resolve, reject) => {
                        const request = superagent[method](formatUrl(path,serverName));
                        request.timeout(timeout || 100000);
                        request.set('Authorization', authToken || this.getToken());
                        if (params) {
                            request.query(params);
                        }

                        if (data) {
                            request.send(data);
                        }

                        request.then((body: Response) => {
                            resolve(body.body)
                        }).catch((err: ResponseError) => {

                            // HACK to redirect to session expired
                            if (err.status === 401) {
                                    window.history.pushState('', '', '/session-expired')
                            }
                            reject(err)
                        });
                    }))
        );
    }

    getToken() {
        if (!this.token) {
            this.token = localStorage.getItem('access_token');

            return this.token
        }
        return this.token;
    }

    setToken(token: string) {
        if (!token) {
            return false;
        }
        localStorage.setItem('backend-auth', token);
        this.token = token;

        return true;
    }
}

export default new wizardClient();
